import Icon from "@kamae-apps/shared/Components/Fondations/Icons/Icon"
import Slider from "@kamae-apps/shared/old/Component/Input/Slider"
import { FC, useState } from "react"
import { CompanyData } from "../../Companies"
import { AutomatedEmailInfo } from "./AutomatedEmailInfo"

type NotificationsSectionProps = {
  company: CompanyData
  onAutomatedEmailChange: (e: any) => void
}

export const NotificationsSection: FC<NotificationsSectionProps> = ({ company, onAutomatedEmailChange }) => {
  const [isInfoDisplayed, setIsInfoDisplayed] = useState(false)

  return (
    <div className={"flex flex-col gap-2"}>
      <h3 className={"mb-2 w-full text-center text-lg"}>Notifications</h3>
      <div className={"flex w-full justify-start gap-2"}>
        <Slider
          id={"companyHasAutomatedEmailEnabled"}
          checked={company.automated_email_enabled ?? false}
          onChange={onAutomatedEmailChange}
          className={"m-1"}
        />
        <label
          htmlFor={"companyHasAutomatedEmailEnabled"}
          className={"flex items-center"}
        >
          <span className={"mr-2"}>Emails automatiques</span>
        </label>
        <button
          type={"button"}
          aria-label={"Ce que pilote l'option Emails automatiques"}
          onClick={() => setIsInfoDisplayed(true)}
          className={"flex items-center text-primary-kamae-500"}
        >
          <Icon
            name={"infoFilled"}
            size={"xs"}
          />
        </button>
      </div>
      <AutomatedEmailInfo
        display={isInfoDisplayed}
        close={() => setIsInfoDisplayed(false)}
      />
    </div>
  )
}
